module.exports = __webpack_public_path__ + "static/img/7291_phase_function_Paper_PointsHejduk_Prediction.7deeea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7291_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 23i9
// module chunks = 0